import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled, { css } from 'styled-components';
export const CommonTextInputStyles = css `
  ${fonts.openSans.light};

  --bgColour: ${brand.global.white};
  --borderColour: ${brand.tertiary.nearlyWhite.light};
  --borderRadius: 6px;
  --placeholderColour: ${brand.grey.grey35};
  --readOnlyColour: ${brand.grey.grey40};
  --textColour: ${brand.primary.base};

  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  background: var(--bgColour);
  border: 2px solid var(--borderColour);
  border-radius: var(--borderRadius);
  color: var(--textColour);
  height: ${fluid(50, 66)};
  font-size: ${fluid(16, 18)};
  margin: 0;
  padding: 0 16px;
  width: 100%;

  &:disabled {
    opacity: 0.5;
    color: var(--readOnlyColour);
    cursor: not-allowed;
  }

  &:read-only,
  &[readonly] {
    color: var(--readOnlyColour);
  }

  &::placeholder {
    color: var(--placeholderColour);
    opacity: 0.5;
  }

  &.focus-ring,
  &:focus-visible {
    --borderColour: ${brand.primary.purple.base};
  }
`;
const Input = styled.input `
  ${CommonTextInputStyles};
`;
const TextboxStyles = {
    Input,
};
export default TextboxStyles;
